"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var core_1 = require("@angular/core");
var BooleanOperatorNameTypePair = /** @class */ (function () {
    function BooleanOperatorNameTypePair(operatorMessageKey, operatorType) {
        this.operatorMessageKey = operatorMessageKey;
        this.operatorType = operatorType;
    }
    return BooleanOperatorNameTypePair;
}());
exports.BooleanOperatorNameTypePair = BooleanOperatorNameTypePair;
/**
 * Mapping boolean operator's message keys to boolean operator types
 *
 * Created by Hayk.Andriasyan on 4/27/2018.
 */
var BooleanOperatorNamesFactory = /** @class */ (function () {
    function BooleanOperatorNamesFactory() {
        this._pairs = [
            new BooleanOperatorNameTypePair('reporting_designer_conditional_formatting_operator_equal', idm_report_export_service_client_js_1.BooleanOperatorType.EQUAL),
            new BooleanOperatorNameTypePair('reporting_designer_conditional_formatting_operator_between', idm_report_export_service_client_js_1.BooleanOperatorType.BETWEEN),
            new BooleanOperatorNameTypePair('reporting_designer_conditional_formatting_operator_great', idm_report_export_service_client_js_1.BooleanOperatorType.GREAT),
            new BooleanOperatorNameTypePair('reporting_designer_conditional_formatting_operator_greater_or_equal', idm_report_export_service_client_js_1.BooleanOperatorType.GREAT_OR_EQUAL),
            new BooleanOperatorNameTypePair('reporting_designer_conditional_formatting_operator_less', idm_report_export_service_client_js_1.BooleanOperatorType.LESS),
            new BooleanOperatorNameTypePair('reporting_designer_conditional_formatting_operator_less_or_equal', idm_report_export_service_client_js_1.BooleanOperatorType.LESS_OR_EQUAL),
            new BooleanOperatorNameTypePair('reporting_designer_conditional_formatting_operator_not_equal', idm_report_export_service_client_js_1.BooleanOperatorType.NOT_EQUAL)
        ];
    }
    BooleanOperatorNamesFactory.prototype.getOperators = function () {
        return this._pairs;
    };
    BooleanOperatorNamesFactory = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], BooleanOperatorNamesFactory);
    return BooleanOperatorNamesFactory;
}());
exports.BooleanOperatorNamesFactory = BooleanOperatorNamesFactory;
//# sourceMappingURL=boolean-operator-names-factory.js.map